import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FaUser } from 'react-icons/fa'
import UserAvatar from './UI/UserAvatar'

const EventHeader = ({ event }) => {
  const navigate = useNavigate()

  return (
    <div className="p-6 border-b border-white/10">
      <div className="flex items-center gap-3 mb-4">
        <UserAvatar user={event.createdBy} />
        <div className="flex-1">
          <p className="text-white font-medium">
            {event.createdBy.username} attended an event
          </p>
          <p className="text-gray-400 text-sm">
            {new Date(event.createdAt).toLocaleDateString()}
          </p>
        </div>
        <button
          onClick={() => navigate('/add-friend', { state: { viewUserId: event.createdBy._id } })}
          className="text-purple-400 hover:text-purple-300 transition-colors"
          title="View friend's profile"
        >
          <FaUser />
        </button>
      </div>
    </div>
  )
}

export default EventHeader